import {
  connectorMeetsMinVersion,
  getConnectorVersion,
} from './connectorVersion';
import { isLocalLibraryCommandError } from '../services/localLibraryIpcGate';

/**
 * First Connector release that grants `local_library_list_scan_skips` to the webview
 * (`allow-local-library-list-scan-skips` in capabilities/default.json).
 *
 * The command and proxy route exist from v11.0.116; shipped builds through v11.0.228
 * reject IPC with ACL until the capability wiring lands in the next regular release.
 */
export const MIN_LIST_SCAN_SKIPS_CONNECTOR = '11.0.229';

export class ScanSkipsListUnsupportedError extends Error {
  constructor(message = scanSkipsListUnsupportedMessage()) {
    super(message);
    this.name = 'ScanSkipsListUnsupportedError';
  }
}

export function isScanSkipsListUnsupportedError(err: unknown): boolean {
  return err instanceof ScanSkipsListUnsupportedError;
}

/** True when the Connector rejected list_scan_skips (ACL or missing command). */
export function isScanSkipsListCommandRejected(err: unknown): boolean {
  return isLocalLibraryCommandError(err);
}

export function scanSkipsListUnsupportedMessage(): string {
  const installed = getConnectorVersion();
  const minLabel = MIN_LIST_SCAN_SKIPS_CONNECTOR;
  const logHint = 'the log names each file';

  if (installed && !connectorMeetsMinVersion(installed, MIN_LIST_SCAN_SKIPS_CONNECTOR)) {
    const installedLabel = installed.replace(/^v/i, '');
    return (
      `Your Maestro version (v${installedLabel}) can't list these yet — `
      + `update to Connector v${minLabel} or newer; ${logHint}.`
    );
  }

  return (
    `Your Maestro version can't list these yet — `
    + `update to the latest release; ${logHint}.`
  );
}

/** Map load failures to a user-safe message; never surface raw ACL text. */
export function resolveScanSkipsListLoadError(err: unknown): string {
  if (isScanSkipsListUnsupportedError(err)) {
    return err.message;
  }
  if (isScanSkipsListCommandRejected(err)) {
    return scanSkipsListUnsupportedMessage();
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message.trim();
  }
  if (typeof err === 'string' && err.trim()) {
    return err.trim();
  }
  return 'Could not load the list';
}
